import * as React from 'react';
import styles from './productLabels.module.scss';

export const ProductLabels = ({ productLabels = [] }: { productLabels: CodeValue[] }) => {
  return (
    <div className={styles.productLabels}>
      {productLabels.map((label) => {
        return (
          <span className={`${styles.label} ${styles[`_${label.code}`]} mb-2`} key={label.code}>
            {label.value}
          </span>
        );
      })}
    </div>
  );
};
